import { createFileRoute, redirect } from '@tanstack/react-router'

import { DeliverablePage } from '@/components/deliverables/deliverable-page'
import { useFollowProjectClient } from '@/hooks/use-current-client'
import { RETURN_SHAPE } from '@/lib/return-to'
import { matching, readSearch } from '@/lib/search-params'

export const Route = createFileRoute('/_app/projects/$projectRef_/livrables_/$key')({
  validateSearch: (search: Record<string, unknown>) =>
    readSearch(
      {
        ...RETURN_SHAPE,
        /** Lot 21 : l'entrée de grille désignée ; depuis #367, sur la page de la grille. */
        controle: matching(/^[0-9a-f]{24}$/),
      },
      search,
    ),
  beforeLoad: ({ params, search }) => {
    // #367 : l'ancienne ancre de la grille mène à sa page.
    if (!search.controle) return
    throw redirect({
      to: '/projects/$projectRef/controles/$key',
      params: { projectRef: params.projectRef, key: params.key },
      search: { controle: search.controle, retour: search.retour },
      replace: true,
    })
  },
  component: DeliverableRoutePage,
})

function DeliverableRoutePage() {
  const { projectRef, key } = Route.useParams()
  useFollowProjectClient(projectRef)
  return <DeliverablePage key={key} projectRef={projectRef} deliverableKey={key} />
}
